import React, { useState } from 'react';
import { Title } from '@/components/Typography';
import { Col, Collapse, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import moment from 'moment';

import { ReviewHistory } from '@/hooks/useGetCustomReportReviewHistory';
import { ReviewFields } from './ReviewFields';
import { ReviewTable } from './ReviewTable';
import { FormContainer } from '../styles';
import { Description } from './styles';

const { Panel } = Collapse;

type FormListItem = ReviewHistory & {
	key: number;
};

interface ReviewsHistoryProps {
	reviewsHistory: ReviewHistory[];
}

export const ReviewsHistory: React.FC<ReviewsHistoryProps> = ({ reviewsHistory }) => {
	const initialFormList = reviewsHistory.map((history, index) => {
		return {
			...history,
			key: index,
			active: false
		};
	});
	const [formList, setFormList] = useState<FormListItem[]>(initialFormList);

	function handleCollapseChange(key: string | string[]) {
		const [, selectedKey] = key;
		const numberKey = Number(selectedKey);
		const formListMapped = mapFormList();
		const index = formListMapped.findIndex((item) => item.key === numberKey);
		if (index < 0) {
			setFormList(formListMapped);
			return;
		}
		formListMapped[index].active = true;
		setFormList(formListMapped);
	}

	function mapFormList() {
		const formListCopy = [...formList];
		const formListMapped = formListCopy.map((item) => ({
			...item,
			active: false
		}));
		return formListMapped;
	}

	const tableData = reviewsHistory?.map((review) => ({
		id: review.id,
		version: review.name,
		evaluator: review.evaluator_name,
		created_at: review.created_at
	}));

	const panels = formList.slice(1).map((history) => {
		const reviewName = history.name.split(' ')[0];
		const reviewNumber = history.name.split(' ')[1];

		return (
			<Panel
				key={`${history.key}`}
				header={
					<Col xs={24}>
						<Row gutter={[0, 0]} justify="space-between" align="middle">
							<Col span={20}>
								<Title style={{ margin: '0 0 0 1rem' }} level={5}>
									{I18n.get(reviewName)} {reviewNumber}
								</Title>
							</Col>
							<Col span={4}>
								<Row align="bottom">
									<Title style={{ margin: '0 0.25rem 0 0', fontSize: '0.8rem' }} level={5}>
										{I18n.get('Reviewed at')}:
									</Title>
									<Description>{moment(history.created_at).format('L')}</Description>
								</Row>
							</Col>
						</Row>
					</Col>
				}
			>
				<Row gutter={[0, 8]} justify="center" key={history.id}>
					<Col xs={24}>
						<Row>
							<ReviewFields stepKeysHistory={history.step_keys_history} />
						</Row>
					</Col>
				</Row>
			</Panel>
		);
	});

	return (
		<FormContainer bordered={false} defaultActiveKey={'header'}>
			<Panel
				key={`header`}
				header={
					<Col xs={24}>
						<Title level={3}>Reviews history</Title>
					</Col>
				}
			>
				<Col span={24} style={{ marginTop: '2rem' }}>
					<ReviewTable data={tableData} />
					<Row justify="center">
						<Col xs={24} style={{ marginTop: '1rem' }}>
							<FormContainer onChange={handleCollapseChange} bordered={false}>
								{panels}
							</FormContainer>
						</Col>
					</Row>
				</Col>
			</Panel>
		</FormContainer>
	);
};
